import useTranslation from 'components/fields/PilotMultiSelectPanelField/hooks/useTranslation';

import useSelectPanelField from 'hooks/useSelectPanelField';
import useUsers from 'hooks/useUsers';

import { DEFAULT_PAGE_SIZE } from './constants';
import type { OrganizationMemberResponse } from './types';

const parsePilots = (pilots: OrganizationMemberResponse[]) =>
    (pilots ?? []).map(({ email, firstName, id, lastName }) => ({
        label: `${firstName ?? ''} ${lastName ?? ''}`.trim() || email,
        value: id
    }));

const useData = () => {
    const { fetchPilots, isLoading, resetPilots } = useUsers();

    const { NO_PILOTS_FOUND } = useTranslation();

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<OrganizationMemberResponse>({
            fetchFn: fetchPilots,
            noItemsFoundText: NO_PILOTS_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: parsePilots,
            resetFn: resetPilots
        });

    return {
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage,
        pilotItems: items
    };
};

export default useData;
